import img from "../../images/gemapi/marivel/1.png";
import map from "../../images/marivelmap.png";
import r1 from "../../images/r1.png";
import r2 from "../../images/r2.jpg";
import r3 from "../../images/r3.png";
import "./carouselAnimation.css";
import timeicon from "../../images/icons/timechek.png";
const MarivelHistory = () => {
  const timelineData = [
    {
      id: 7,
      title: "Dès 1874 :",

      description:
        " On note des inquiétudes sur les maçonneries existantes. De plus dès 1875 : une augmentation de certaines sections est nécessaire, car les inondations sont fréquentes. 8 octobre 1866 : Décret annonçant la construction, en domaine public, sous la RN10 (facilités d’exploitation), d’un égout devant recueillir les eaux usées, afin de réserver le Ru de Marivel aux eaux pluviales.",
    },
    {
      id: 6,
      title: "1867 et plus :",

      description:
        " Le ru de Marivel (long de 7 km environ, dont 6,6 km situés en propriété privée, sa source est située en limite Est de la Commune de Versailles, son exutoire en Seine, à 80m en amont du Pont de Sèvres), est canalisé, d’abord à Chaville et à Viroflay, le plus souvent par les riverains, et dans des conditions délictueuses, avec des sections limitées (1m x 1m maximum) sur 2/3 du parcours (en 1928 sont signalés deux tronçons résiduels non couverts : sur 80m, au n°87 de la Grande Rue à Sèvres, et sur 100m, dans les Jardins de la Manufacture de Porcelaine, à Sèvres là aussi).",
    },
    {
      id: 5,
      title: "1865 :",

      description:
        " Menace d’une épidémie de choléra : Le Ministre prescrit la production immédiate de projets afin d’améliorer l’état du Ru, insalubre.",
    },
    {
      id: 4,
      title: "29 juin 1853 :",

      description:
        " Établissement du règlement pour la Police du Ru de Marivel, afin de protéger la qualité du cours d’eau ; il est interdit de déverser des eaux usées dans le Ru de Marivel.",
    },
    {
      id: 3,
      title: "1810 :",

      description:
        " Premiers Arrêtés Préfectoraux ordonnant la suppression des latrines sur le Ru.",
    },
    {
      id: 2,
      title: "1791 :",

      description:
        " Arrêtés Préfectoraux ordonnant le curage et l’entretien du Ru par les riverains ; ceux-ci devront ni gêner le libre écoulement des eaux, ni détourner celles-ci.",
    },
    {
      id: 1,
      title: "1790 et 1791 :",

      description:
        " Écrits (Mémoire rédigé par la Municipalité de Sèvres ; Procès verbal du Directoire du district de Versailles) relatifs aux nuisances occasionnées au Ru par les vidanges de fosse d’aisances ; le Ru (alimenté par plusieurs sources) est, en ce temps, utilisé pour l’alimentation et les travaux de blanchisserie.",
    },
  ];
  return (
    <div>
      <section
        className="p-4 text-center sm:p-6 md:p-10 lg:p-20 bg-black/70 bg-blend-overlay"
        style={{
          backgroundImage: `url(${map})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <h1 className="text-xl font-bold text-center text-white sm:text-2xl md:text-3xl">
          L’historique du ru de Marivel
        </h1>
      </section>

      <div className="container px-4 mx-auto mt-8 mb-10 sm:mt-20 sm:px-6 lg:px-8">
        <p className="text-base text-black text-start">
          Le réseau de transport du SIAVRM est organisé autour d’un axe central
          de transport des effluents qui suit le tracé de la voirie
          départementale qui relie Versailles à Sèvres (RD 10 sur le département
          des Yvelines et RD 910 sur le département des Hauts de Seine). Il est
          complété par deux antennes latérales, en direction de Ville d’Avray et
          Marnes la Coquette d’une part (Nord Ouest), de Chaville et Vélizy
          d’autre part (Sud). <br /> L’évolution des capacités de transport du
          réseau du SIAVRM a dû suivre l’extension progressive de l’urbanisation
          à des zones anciennement rurales sur le bassin versant. Sur un siècle,
          l’imperméabilisation du bassin versant du ru de Marivel a été
          radicalement modifiée.
        </p>
      </div>

      <div className="container px-4 mx-auto mt-8 mb-10 sm:mt-10 sm:px-6 lg:px-8">
        <div className="flex justify-center">
          <img
            src={img}
            alt="Historical scene of Ru de Marivel area"
            className="w-full h-auto max-w-xs rounded-lg sm:max-w-sm"
          />
        </div>
      </div>

      <div className="container px-4 mx-auto mt-8 mb-10 sm:mt-10 sm:px-6 lg:px-8">
        <ol className="relative border-gray-200 border-s border-primary dark:border-gray-700">
          {[...timelineData]
            .sort((a, b) => a.id - b.id) // Sort by id in ascending order
            .map((item) => (
              <li className="mb-10 ms-6" key={item.id}>
                <span className="absolute flex items-center justify-center w-8 h-8 -ml-1 rounded-full bg-primary -start-3 dark:ring-gray-900 dark:bg-blue-900">
                  <div
                    className="w-6 h-6 mx-auto bg-white"
                    style={{
                      mask: `url(${timeicon}) no-repeat center`,
                      maskSize: "contain",
                      WebkitMask: `url(${timeicon}) no-repeat center`,
                      WebkitMaskSize: "contain",
                    }}
                  />
                </span>
                <span className="items-center mb-1 text-lg font-semibold text-black dark:text-white">
                  {item.title}{" "}
                  <span className="mb-4 text-base font-normal text-gray-500 dark:text-gray-400">
                    {item.description}
                  </span>
                </span>
              </li>
            ))}
        </ol>
      </div>
      <div className="mt-24 mb-20 md:pl-96 sm:pl-12">
        <div className="relative bg-primary h-96 md:h-40">
          {/* Mobile: Stacked vertically */}
          <div className="md:hidden">
            <div className="absolute z-10 transform -translate-x-1/2 left-1/2 -top-16">
              <img
                src={r1}
                alt=""
                className="object-cover w-64 h-48 grayscale"
              />
            </div>
            <div className="absolute z-10 transform -translate-x-1/2 left-1/2 top-8">
              <img
                src={r2}
                alt=""
                className="object-cover w-64 h-48 grayscale"
              />
            </div>
            <div className="absolute z-10 transform -translate-x-1/2 left-1/2 top-32">
              <img
                src={r3}
                alt=""
                className="object-cover w-64 h-48 grayscale"
              />
            </div>
          </div>

          {/* Medium and Large screens: Your original design */}
          <div className="hidden md:block">
            <div className="absolute z-10 -top-16 -left-5">
              <img
                src={r1}
                alt=""
                className="object-cover w-64 h-48 grayscale"
              />
            </div>
            <div className="absolute z-10 transform -translate-x-1/2 -top-16 left-1/3">
              <img
                src={r2}
                alt=""
                className="object-cover w-64 h-48 grayscale"
              />
            </div>
            <div className="absolute z-10 -top-16 left-2/4">
              <img
                src={r3}
                alt=""
                className="object-cover w-64 h-48 grayscale"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarivelHistory;
